import { createAsyncThunk } from "@reduxjs/toolkit";
import OrganizationAPI, { OrganizationApiUrls } from "../API/OrganizationAPI";

import LocalStorage from "../../../../Services/Storage/LocalStorage";
import StorageModel from "../../../../Models/StorageModel";
import HttpsClient from "../../../../Services/HttpsClient";
import ApiHelper from "../../../../Services/ApiHelper";
import Cache from "../../../../Services/Cache";

const storage = new LocalStorage();
const storageModel = new StorageModel(storage);
const cache = new Cache(storageModel);

const httpsClient = new HttpsClient();
const apiHelper = new ApiHelper(httpsClient);
const organizationAPI = new OrganizationAPI(apiHelper, cache);

// JobLevel Thunks
export const getAllJobLevels = createAsyncThunk(
  OrganizationApiUrls.getAllJobLevels,
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;

    return await organizationAPI.getAllJobLevels(token);
  }
);

export const createJobLevel = createAsyncThunk(
  OrganizationApiUrls.createJobLevel + "/create",
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;

    await organizationAPI.createJobLevel(payload, token);
    dispatch(getAllJobLevels());

    return;
  }
);

export const updateJobLevel = createAsyncThunk(
  OrganizationApiUrls.updateJobLevel + "/update",
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;

    await organizationAPI.updateJobLevel(payload, token);
    dispatch(getAllJobLevels());

    return;
  }
);

export const deleteJobLevel = createAsyncThunk(
  OrganizationApiUrls.deleteJobLevel + "/delete",
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;

    await organizationAPI.deleteJobLevel(payload, token);
    dispatch(getAllJobLevels());

    return;
  }
);

// JobGroup Thunks
export const getAllJobGroups = createAsyncThunk(
  OrganizationApiUrls.getAllJobGroups,
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;

    return await organizationAPI.getAllJobGroups(token);
  }
);

export const createJobGroup = createAsyncThunk(
  OrganizationApiUrls.createJobGroup + "/create",
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;

    await organizationAPI.createJobGroup(payload, token);
    dispatch(getAllJobGroups());

    return;
  }
);

export const updateJobGroup = createAsyncThunk(
  OrganizationApiUrls.updateJobGroup + "/update",
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;

    await organizationAPI.updateJobGroup(payload, token);
    dispatch(getAllJobGroups());

    return;
  }
);

export const deleteJobGroup = createAsyncThunk(
  OrganizationApiUrls.deleteJobGroup + "/delete",
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;

    await organizationAPI.deleteJobGroup(payload, token);
    dispatch(getAllJobGroups());

    return;
  }
);

// Department Thunks
export const getAllDepartments = createAsyncThunk(
  OrganizationApiUrls.getAllDepartments,
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;

    return await organizationAPI.getAllDepartments(token);
  }
);

export const createDepartment = createAsyncThunk(
  OrganizationApiUrls.createDepartment + "/create",
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;

    await organizationAPI.createDepartment(payload, token);
    dispatch(getAllDepartments());

    return;
  }
);

export const updateDepartment = createAsyncThunk(
  OrganizationApiUrls.updateDepartment + "/update",
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;

    await organizationAPI.updateDepartment(payload, token);
    dispatch(getAllDepartments());

    return;
  }
);

export const deleteDepartment = createAsyncThunk(
  OrganizationApiUrls.deleteDepartment + "/delete",
  async (payload, { getState, dispatch }) => {
    const state = getState();
    const token = state.auth.user.token;

    await organizationAPI.deleteDepartment(payload, token);
    dispatch(getAllDepartments());

    return;
  }
);
